import { type PropsWithChildren, useContext } from 'react';
import { createStyles } from '@mantine/core';

import { Routes } from '~/domains/common/constants/routes';
import AppBanners from '~/domains/common/components/AppBanners/AppBanners';

import GamecenterHeader from '../GamecenterHeader/GamecenterHeader';
import { useContestContext } from '../../context/ContestContext/ContestContext';
import GamecenterPrevPathContext from '../../context/GamecenterPrevPathContext/GamecenterPrevPathContext';

import GamecenterScheduledNav from './GamecenterScheduleNav';

const useStyles = createStyles((theme) => ({
  container: {
    minHeight: '100%',
  },
  headerContainer: {
    position: 'sticky',
    top: 0,
    zIndex: theme.other.zIndex.header,
  },
}));

function GamecenterScheduledLayout({
  children,
  headerSlot,
}: PropsWithChildren<{ headerSlot?: JSX.Element }>) {
  const { classes } = useStyles();
  const { prevLocationBeforeGamecenter } = useContext(GamecenterPrevPathContext);
  const { contest } = useContestContext();

  const prevRoute = prevLocationBeforeGamecenter ?? Routes.myEntries();

  return (
    <div className={classes.container}>
      <div className={classes.headerContainer}>
        <GamecenterHeader closeHref={prevRoute} contest={contest} />
        <GamecenterScheduledNav contest={contest} />
        <AppBanners />
        {headerSlot}
      </div>
      {children}
    </div>
  );
}

export default GamecenterScheduledLayout;
